import { render, staticRenderFns } from "./DeliverySelectModal.vue?vue&type=template&id=fa8b501c&scoped=true"
import script from "./DeliverySelectModal.vue?vue&type=script&lang=js"
export * from "./DeliverySelectModal.vue?vue&type=script&lang=js"
import style0 from "./DeliverySelectModal.vue?vue&type=style&index=0&id=fa8b501c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8b501c",
  null
  
)

export default component.exports